export const qs = <T extends HTMLElement>(selector: string, parent: ParentNode = document): T | null =>
  parent.querySelector<T>(selector);

export const qsa = <T extends HTMLElement>(selector: string, parent: ParentNode = document): T[] =>
  Array.from(parent.querySelectorAll<T>(selector));

export const onReady = (callback: () => void): void => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
  } else {
    callback();
  }
};

export const clamp = (value: number, min: number, max: number): number => Math.min(Math.max(value, min), max);

export const lerp = (start: number, end: number, factor: number): number => start + (end - start) * factor;

export const prefersReducedMotion = (): boolean => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const isTouchDevice = (): boolean => window.matchMedia('(pointer: coarse)').matches;
